import axios from 'axios'
import { getAccessToken, solicitarNovoToken, logoutToPortal } from '@/auth/token'

const url = process.env.VUE_APP_API_URL

export const http = axios.create({
  baseURL: url,
})

http.defaults.timeout = 90000000

// Interceptor de requisição: injeta o Bearer token automaticamente
http.interceptors.request.use(
  (config) => {
    const token = getAccessToken()
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }
    return config
  },
  (error) => Promise.reject(error),
)

// Interceptor de resposta: em 401 tenta renovar o token via portal Pulse;
// se não conseguir, redireciona para o portal (logoutToPortal).
let _renovandoToken = false

http.interceptors.response.use(
  (response) => response,
  async (error) => {
    if (error.response && error.response.status === 401 && !_renovandoToken) {
      _renovandoToken = true
      try {
        const novoToken = await solicitarNovoToken()
        if (novoToken) {
          // Repete a requisição original com o novo token
          const originalRequest = error.config
          originalRequest.headers.Authorization = `Bearer ${novoToken}`
          _renovandoToken = false
          return http(originalRequest)
        }
      } catch (e) {
        // ignore
      }
      _renovandoToken = false
      logoutToPortal()
    }
    return Promise.reject(error)
  },
)

export default {
  url,
}
